import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-terms-and-conditions',
  templateUrl: './payment-terms-and-conditions.component.html',
  styleUrls: ['./payment-terms-and-conditions.component.scss']
})
export class PaymentTermsAndConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
